
import { FC } from "react";
import { AuthenticatedLayout } from "../../layouts";
import { TaxProfileSetup } from "../../components/TaxProfile";

export interface ITaxProfileSetupPage {}

export const TaxProfileSetupPage: FC<ITaxProfileSetupPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Tax Profile Setup"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{ text: "Create Tax Profile", navigateTo: "/tax-profile/list" },
      { text: "Create Tax Profile", navigateTo: "/tax-profile/setup" }]}
      mainContents={<TaxProfileSetup testId="tax-profile-setup" />}
    />
  );
};
